app.directive('fieldTags', ['$window', '$rootScope', '$timeout', function ($window, $rootScope, $timeout) {

    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            'datas': '=',
            'edition': '=edition',
            'placeholder': '@',
            'classes': '@',
            'myChange':'&',
            'ngChangeSearchText': '&',
            'ngModel': '=?searchText'
        },
        templateUrl: "application/templates/directives/fieldTags.html",
        link: function (scope, element, attrs) {



            var update = function () {

                $timeout(function () {

                    scope.countInvisibles = 0;
                    var tags = ($(element[0]).find('.tag-visible'));

                    $.each(tags, function (index, tag) {
                        var position = $(tag).position();
                        var height = $(tag).height();
                        if (position.top > height) {
                            scope.datas[$(tag).data('index')]._isVisible = false;
                            scope.countInvisibles++;
                        } else {
                            scope.datas[$(tag).data('index')]._isVisible = true;
                        }
                    });

                });
            };



            $rootScope.$on('windowResize', update);
            $rootScope.$on('updateFieldTags', update);
            angular.element(document).ready(function () {
                $timeout(function () {
                    update();
                }, 0);
            });
        },

        controller: function ($scope) {
            $scope.config = {
                setHeight: 40 * $scope.datas.length,
            };
        }
    }
}]);